module.exports = __webpack_public_path__ + "img/img-12@2x.c6dbaf0e.png";